import { type FC } from 'react';
import { Link } from 'react-router';
import { Button, Group, Paper, Stack, Text, Title } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { createPayoutCascadesUrl } from '~/entities/payout';

interface CascadeEditorHeaderProps {
    isNew: boolean;
    cascadeId?: string;
}

export const CascadeEditorHeader: FC<CascadeEditorHeaderProps> = ({ isNew, cascadeId }) => {
    return (
        <Paper
            p='md'
            radius='md'
            withBorder
        >
            <Stack gap={4}>
                <Button
                    component={Link}
                    to={createPayoutCascadesUrl('cascades')}
                    variant='subtle'
                    size='xs'
                    w='fit-content'
                    leftSection={<IconArrowLeft size={16} />}
                >
                    К списку каскадов
                </Button>

                <Group
                    gap='xs'
                    align='center'
                >
                    <Title
                        order={2}
                        size='h3'
                    >
                        {isNew ? 'Новый каскад' : 'Каскад'}
                    </Title>
                </Group>

                {!isNew && (
                    <Text
                        size='sm'
                        c='dimmed'
                    >
                        {cascadeId}
                    </Text>
                )}
            </Stack>
        </Paper>
    );
};
